export const LABELS = {
  TITLE: 'title',
  ID: 'ID',
  ISSUE_TITLE: 'issueTitle',
  ISSUE_DATE: 'issueDate',
  PATIENT_NAME: 'patientName',
  SRC_ORG_NAME: 'srcOrgName',
  PATIENT_GENDER: 'patientGender',
  DEPARTMENT: 'department',
  PATIENT_BIRTHDAY_DATE: 'patientBirthdayDate',
  DOCTORS_FROM_SRC_ORG: 'doctorsFromSrcOrg',
  TAGS: 'tags',
  DESCRIPTION: 'description',
  DIAGNOSIS: 'diagnosis',
  MEASURES: 'measures',
  KEY_IMAGES: 'keyImages',
  REPORT_DATE: 'reportDate',
  SIGNATURE: 'signature',
};

export const KEY_LABELS = {
  [LABELS.TITLE]: 'issue_details_report_preview_text_report_filename',
  [LABELS.ID]: 'issue_details_report_preview_text_id',
  [LABELS.ISSUE_TITLE]: 'issue_details_report_preview_text_issue_title',
  [LABELS.ISSUE_DATE]: 'issue_details_report_preview_text_issue_date',
  [LABELS.PATIENT_NAME]: 'issue_details_report_preview_text_patient_name',
  [LABELS.SRC_ORG_NAME]: 'issue_details_report_preview_text_src_org_name',
  [LABELS.PATIENT_GENDER]: 'issue_details_report_preview_text_patient_gender',
  [LABELS.DEPARTMENT]: 'issue_details_report_preview_text_department',
  [LABELS.PATIENT_BIRTHDAY_DATE]:
    'issue_details_report_preview_text_patient_birthday',
  [LABELS.DOCTORS_FROM_SRC_ORG]:
    'issue_details_report_preview_text_doctors_from_src_org',
  [LABELS.TAGS]: 'issue_details_report_preview_text_tags',
  [LABELS.DESCRIPTION]: 'issue_details_report_preview_text_description',
  [LABELS.DIAGNOSIS]: 'issue_details_report_preview_text_diagnosis',
  [LABELS.MEASURES]: 'issue_details_report_preview_text_measures',
  [LABELS.KEY_IMAGES]: 'issue_details_report_preview_text_key_images',
  [LABELS.REPORT_DATE]: 'issue_details_report_preview_text_report_date',
  [LABELS.SIGNATURE]: 'issue_details_report_preview_text_signature',
};

export const getValueFromLabel = (content, key) => {
  return content.find((s) => s.label === key)?.value || '';
};
